import * as React from 'react';
import ReactJson from 'react-json-view';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { DATA_STATE } from '../types/demo';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class DemoApiResponse extends React.Component<any, any> {
    public render() {
        const isProcessing = DATA_STATE.PROCESSING === this.props.demo.state
        return (
            <div style={this.props.style}>
                <Dialog
                    fullScreen={true} 
                    open={this.props.demo.showResult}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Result</DialogTitle>
                    <DialogContent>
                        {isProcessing ? (
                            <CircularProgress />
                        ) : (
                            <DialogContentText id="alert-dialog-description">
                                <ReactJson src={this.props.demo.result} />
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.handleClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(DemoApiResponse));



// WEBPACK FOOTER //
// ./src/components/demo-api-response.tsx